/* global ENV */
import context from './util/context';
const env = { ...ENV, ...(context.__ENV__ || {}) };

if (env.PUSHBOT_VERBOSE) {
  console.groupCollapsed(
    'environment',
    `${env.PUSHBOT_CONFIGURATION}@${env.PUSHBOT_VERSION}`
  );
  Object.keys(env).forEach(k =>
    console.log(
      `%c${k}%c: %c${JSON.stringify(env[k])}`,
      'color: #93c',
      'color: #999',
      'color: #d13'
    )
  );
  console.groupEnd();
}

export default env;



// WEBPACK FOOTER //
// ./js/env.js